import { GET_DEPOSITS, FETCH_RATESHEET_FULFILLED } from './actions'
import { calculate } from './calculate'
import { combineReducers } from 'redux'

const initialState = {
  deposit: 0,
  firstYrInterest: 0,
  blendedAPY: 0,
  rateSheet: [],
  tiers: [],
}

export const deposits = (state = initialState, action) => {
  switch (action.type) {
    case GET_DEPOSITS:
      return {
        ...state,
        ...calculate(action.payload, state.rateSheet),
      }

    case FETCH_RATESHEET_FULFILLED:
      const rateSheet = action.payload
      return {
        ...state,
        rateSheet,
        tiers: rateSheet.map(tier => ({
          ...tier,
          interest: 0,
          amount: 0,
        })),
      }

    default:
      return state
  }
}

export const rootReducer = combineReducers({
  deposits,
})



// WEBPACK FOOTER //
// ./src/reducers.js